import React from "react";

const Mission = () => {
  const stats = [
    { value: "500+", label: "TONS" },
    { value: "25+", label: "COUNTRIES" },
    { value: "100%", label: "ORGANIC" },
    { value: "10+", label: "YEARS" },
  ];

  return (
    <section id="mission" className="py-16 md:py-24 bg-white scroll-mt-16">
      <div className="container mx-auto px-4">
        {/* The Main Mission Card */}
        <div className="bg-slate-50 border border-slate-100 rounded-[2.5rem] p-8 md:p-16 shadow-sm">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Side: Text Content */}
            <div className="space-y-6">
              <h2 className="text-3xl md:text-5xl font-black text-primary uppercase tracking-tighter">
                Our Mission
              </h2>
              <div className="w-16 h-1.5 bg-accent"></div>
              <p className="text-lg md:text-xl text-slate-600 leading-relaxed font-medium max-w-xl">
                To provide the world with the finest organic dehydrated powders
                and quality groceries from India, supporting sustainable farming
                practices.
              </p>
            </div>

            {/* Right Side: Stats Grid (Cards inside the Main Card) */}
            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {stats.map((stat, idx) => (
                <div
                  key={idx}
                  className="bg-white border border-slate-100 p-6 md:p-10 rounded-3xl flex flex-col items-center justify-center text-center shadow-sm hover:shadow-md transition-all duration-300"
                >
                  <span className="text-3xl md:text-5xl font-black text-accent mb-2">
                    {stat.value}
                  </span>
                  <span className="text-[10px] md:text-xs font-bold text-slate-400 uppercase tracking-[0.2em]">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
